import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { tl } from '../utils/inlineI18n';
import './StoryTalk.css';

const TYPE_MS = 22;

// Görev bitince bir karakterin söylediği satırlar: daktilo efektiyle tek tek gösterilir.
const StoryTalk = ({ speaker, lines, onClose }) => {
  const [idx, setIdx] = useState(0);
  const [shown, setShown] = useState('');
  const line = lines[idx] || '';
  const typing = shown.length < line.length;
  const last = idx >= lines.length - 1;

  useEffect(() => {
    setShown('');
    let i = 0;
    const t = setInterval(() => {
      i += 1;
      setShown(line.slice(0, i));
      if (i >= line.length) clearInterval(t);
    }, TYPE_MS);
    return () => clearInterval(t);
  }, [line]);

  const next = () => {
    if (typing) { setShown(line); return; }
    if (last) onClose?.();
    else setIdx((v) => v + 1);
  };

  return createPortal(
    <div className="story-talk" role="dialog" aria-modal="true" onClick={next}>
      <div className="story-talk__box" onClick={(e) => { e.stopPropagation(); next(); }}>
        {speaker ? <div className="story-talk__speaker">{speaker}</div> : null}
        <p className="story-talk__line">{shown}</p>
        <div className="story-talk__foot">
          <span>{idx + 1}/{lines.length}</span>
          <span>{typing ? '' : last ? tl('Kapat ▸', 'Close ▸') : tl('Devam ▸', 'Continue ▸')}</span>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default StoryTalk;
